import styled from "styled-components"
import { RowsContainer } from "component_library/components/react/FlexDiv"

const Content = styled(RowsContainer)`
  padding: 0px ${({ theme }) => theme.spacing[5]};
`

export default Content
